import {
  ReaCheckResponse,
  ReaCheckViewState,
} from 'src/app/models/fincas/rea.model';

/**
 * Builds a customer-friendly view model for the initial REA availability check.
 */
export class ReaImportCheckPresenter {
  public static map(check: ReaCheckResponse | null, canContinueWithProvidedRea: boolean): ReaCheckViewState {
    const reaCount = check?.reaCount ?? 0;
    const hasSeveralReas = check?.requiresSelection === true;

    return {
      title: hasSeveralReas ? 'Elige la explotación REA' : 'Comprobación inicial',
      countLabel: this.countLabel(reaCount),
      notice: this.notice(check, canContinueWithProvidedRea),
      confirmedReaLabel: check?.selectedRea != null ? `REA confirmado: ${check.selectedRea}` : '',
      emptyLabel: this.emptyLabel(check),
      providedReaLabel: 'Se usará el REA indicado para continuar la importación.',
      canContinueWithProvidedRea,
    };
  }

  private static countLabel(reaCount: number): string {
    return reaCount === 1 ? '1 REA encontrado' : `${reaCount} REA encontrados`;
  }

  private static notice(check: ReaCheckResponse | null, canContinueWithProvidedRea: boolean): string {
    if (check?.testFallbackEnabled === true) {
      return [
        'No se ha podido comprobar el REA en FEGA.',
        'Se intentará importar usando el entorno de pruebas con el NIF/CIF indicado.',
        'Si se encuentran datos, el código REA se obtendrá automáticamente.',
      ].join(' ');
    }

    if (canContinueWithProvidedRea) {
      return 'Se usará el código REA indicado para continuar la importación.';
    }

    return '';
  }

  private static emptyLabel(check: ReaCheckResponse | null): string {
    if (check?.testFallbackEnabled === true) {
      return 'Se continuará con el NIF/CIF indicado; no hace falta introducir un código REA manualmente.';
    }

    return 'No se han encontrado REA asociados para importar.';
  }
}
